/**
 * 设置根元素字体大小
 * 1440px下不变，大于1440按比例缩放
 */
function setRootFontSize() {
    const screenWidth = window.innerWidth
    if (screenWidth <= 1440) {
        document.documentElement.style.fontSize = '10px'
    } else {
        document.documentElement.style.fontSize = `${(screenWidth / 1440) * 10}px`
    }
}

setRootFontSize()

// 监听窗口大小变化
window.addEventListener('resize', setRootFontSize)
